import React, { useEffect, useState } from "react";
import { ImageIcon, Loader2 } from "lucide-react";

import { api } from "@/lib/api";

export default function PrivateReferenceImage({ reference, className = "", onReady }) {
  const [src, setSrc] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = "";
    setSrc("");
    setFailed(false);
    onReady?.(reference.id, "");

    if (!reference.image_url) {
      setFailed(true);
      return undefined;
    }
    const mediaPath = reference.image_url.replace(/^\/api\/?/, "/");
    api.get(mediaPath, { responseType: "blob" })
      .then(({ data }) => {
        if (!data || !/^image\/(jpeg|png|webp)$/i.test(data.type || "")) {
          throw new Error("Media response is not a supported image");
        }
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setSrc(objectUrl);
        onReady?.(reference.id, objectUrl);
      })
      .catch(() => { if (!cancelled) setFailed(true); });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [reference.id, reference.image_url, onReady]);

  if (failed) {
    return (
      <div className="h-full w-full grid place-items-center px-3 text-center text-[#806B52]"
           role="img" aria-label="Не удалось загрузить визуальный референс"
           data-testid="brand-reference-image-error">
        <span className="grid place-items-center gap-2 text-[12px] leading-relaxed">
          <ImageIcon size={22} strokeWidth={1.5} /> Не удалось загрузить изображение
        </span>
      </div>
    );
  }
  if (!src) {
    return <div className="h-full w-full grid place-items-center text-[#B9A692]" aria-label="Загружаем изображение">
      <Loader2 size={18} className="animate-spin" />
    </div>;
  }
  return <img src={src} alt="Визуальный референс бренда" className={className}
              onError={() => setFailed(true)} data-testid="brand-reference-image" />;
}
